import React from 'react';
import {browserHistory} from 'react-router';

import './ProfilePage.sass';

import {connect} from 'react-redux';
import {deAuthorizeToken} from '../../ducks/auth';
import {setBackground, openModal} from '../../ducks/ui';

import Button from '../../components/button/Button';
import ChannelPrice from '../../containers/channelUtils/ChannelPrice';
import WalletCheckoutModalContainer from '../walletDepositModalContainer/WalletDepositModalContainer';

import {FormattedMessage} from 'react-intl';
import ChannelLink from '../channelUtils/ChannelLink';
import withChannelFormatters from '../channelUtils/withChannelFormatters';

@withChannelFormatters
@connect(({auth, user}) => ({token: auth.token, profile: user.profile}))
export default class ProfilePage extends React.PureComponent {
  static navMenu = [
    {
      id: 'profile',
      name: 'section.profile.user-profile',
      slug: '/profile',
      props: {
        onlyActiveOnIndex: true
      }
    },
    {
      id: 'orders',
      name: 'section.profile.orders',
      slug: '/profile/orders'
    }
  ];

  addBalance = () => {
    this.props.dispatch(openModal(WalletCheckoutModalContainer));
  };

  componentDidMount() {
    const {dispatch} = this.props;

    dispatch(setBackground());
  }

  render() {
    const {children, dispatch, token, channelFormatters, profile} = this.props;

    return (
      <div className="container">
        <div className="row">
          <aside className="menu  menu--no-gradient">
            <div className="profile__wallet">
              <div className="profile__wallet-funds">
                <ChannelPrice price={profile && profile.wallet && profile.wallet.balance}/>
              </div>
              <button
                className="profile__wallet-add btn btn--filled btn--extraSmall"
                onClick={this.addBalance}
              >
                <FormattedMessage id="section.profile.add-funds"/>
              </button>
            </div>

            <div className="menu__content">
              {ProfilePage.navMenu.map(({id, name, slug, props = {}}) => (
                <ChannelLink
                  key={id}
                  to={slug}
                  className="menu__item"
                  activeClassName="menu__item--active"
                  {...props}
                >
                  <span className="menu__title">
                    <FormattedMessage id={name}/>
                  </span>
                </ChannelLink>
              ))}
            </div>

            <Button
              sign
              onClick={() => {
                dispatch(deAuthorizeToken(token));
                browserHistory.push(channelFormatters.link('/'));
              }}
            >
              <FormattedMessage id="section.auth.sign-out.action"/>
            </Button>
          </aside>

          {children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/profilePage/ProfilePage.js